import { render, staticRenderFns } from "./DonutChart10.vue?vue&type=template&id=3cbae4e0&scoped=true&"
import script from "./DonutChart10.vue?vue&type=script&lang=js&"
export * from "./DonutChart10.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbae4e0",
  null
  
)

export default component.exports